import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckBoxGroupComponent } from './check-box-group.component';
import {ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule
  ],
  declarations: [CheckBoxGroupComponent],
  exports: [CheckBoxGroupComponent]
})
export class jDCheckBoxModule { }
